import React, { useCallback } from 'react';
import classnames from 'classnames';
import Checkbox from 'ui/Checkbox';

export interface IMultiSelectWithSearchOption {
  label?: string;
  value: string;
  renderItem?: (isSelected: boolean, className?: string) => React.ReactElement;
}

export interface IMultiSelectOptionProps {
  option: IMultiSelectWithSearchOption;
  isSelected: boolean;
  onSelect: (optionId: string) => void;
}

export const MultiSelectOption: React.FC<IMultiSelectOptionProps> = React.memo(({ option, isSelected, onSelect }) => {
  const handleOptionSelect = useCallback((e) => {
    e.stopPropagation();
    onSelect(option.value);
  }, [onSelect, option.value]);

  return (
    <div
      key={`${option.value} ${option.label}`}
      className={classnames(`value-${option.value}`, 'flex items-center justify-between hover:bg-teal-40')}
      onClick={handleOptionSelect}
    >
      <div className="flex items-center flex-1 min-w-0">
        <div
          className="flex items-center h-[35px] cursor-pointer"
          onClick={handleOptionSelect}
        >
          <div className="px-10px">
            <Checkbox
              checked={isSelected}
              onChange={handleOptionSelect}
            />
          </div>
        </div>
        {option.renderItem ? (
          option.renderItem(
            isSelected,
            classnames({
              'font-bold': isSelected,
            })
          )
        ) : (
          <span className={classnames('block font-pt-sans text-16px leading-[normal]', { 'font-bold': isSelected })}>
            {option.label}
          </span>
        )}
      </div>
    </div>
  );
});
